import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./Injector.module.scss";

const InjectorAd = ({ className, ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, className)}
      format="injector"
      sizesAt0="mobile-wide"
      sizesAt976="desktop-wide"
      {...props}
    />
  );
};

export default InjectorAd;
